export const randKey = () => {
  return Math.floor(Math.random() * 1000000).toString();
};

export const isEmpty = (obj) => {
  return (
    obj &&
    Object.keys(obj).length === 0 &&
    Object.getPrototypeOf(obj) === Object.prototype
  );
};

export const ending = (num, words) => {
  let ending;
  const n = num % 100;
  if (n >= 11 && n <= 19) {
    return words[2];
  }
  switch (n % 10) {
    case 1:
      [ending] = words;
      break;
    case 2:
    case 3:
    case 4:
      [, ending] = words;
      break;
    default:
      [, , ending] = words;
  }
  return ending;
};

export const parseURL = (url) => {
  const [path, q] = url.split('?');
  const params = Array.from(new URLSearchParams(q).entries()).reduce(
    (acc, p) => {
      const [key, val] = p;
      acc[key] = val;
      return acc;
    },
    {},
  );

  return { path, params };
};

export const prodNumStr = (num) => {
  return ending(num, ['товар', 'товара', 'товаров']);
};

const kwRegex = /(?=(?:\d{3})+$)/;
export const fmtNum = (number, sep) => {
  if (sep === undefined) {
    sep = ' ';
  }

  const num = Math.ceil(number) + '';
  return num.split(kwRegex).join(sep);
};

export const fmtFloatNum = (number, maxFracDgts = 2) => {
  if (number === null) {
    return null;
  }

  const num = number.toLocaleString('ru-RU', {
    minimumFractionDigits: 2,
    maximumFractionDigits: maxFracDgts,
  });
  return num;
};

export const cookUrl = (path, params) => {
  let newPath = path;
  if (!isEmpty(params)) {
    newPath += '?' + new URLSearchParams(params);
  }
  return newPath;
};

export const commaReplace = /,/g;
export const dotReplace = /\.+/g;
